import React, { forwardRef } from "react";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import { format } from "date-fns";

const PhieuInChiTiet = forwardRef(({ item }, ref) => {
  if (!item) return null;
  const currentUrl = typeof window !== "undefined" ? window.location.href : "";
  const currentTime = format(new Date(), "HH:mm dd/MM/yy");
  return (
    <>
      <div
        ref={ref}
        style={{
          width: "900px",
          margin: "0 auto",
          fontFamily: "Times New Roman, serif",
          fontSize: "18px",
          color: "#000",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          minHeight: "1122px",
          position: "relative",
          boxSizing: "border-box",
          paddingBottom: "60px",
        }}
      >
        {/* Header trên cùng */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "14px",
            marginBottom: "10px",
            marginTop: "10px",
          }}
        >
          <div>{currentTime}</div>
          <div>Danh sách tất toán | Phần mềm quản lý cầm đồ - Morman</div>
        </div>

        {/* Tiêu đề chính */}
        <div style={{ flex: 1 }}>
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <h3 style={{ margin: 0, fontWeight: "bold" }}>
              Thông Tin Tất Toán
            </h3>
            <div style={{ fontWeight: "bold" }}>
              {getDate(item?.Time ? item.Time : new Date())}
            </div>
          </div>

          <div style={{ lineHeight: "2.0" }}>
            <div>
              Tên khách hàng:{" "}
              <b>
                {item?.nameCus}
                <br />
                {item?.Phone}
              </b>
            </div>
            <div>
              Địa chỉ: <b>{item?.Address}</b>
            </div>
            <div>SDT:</div>
            <div>
              Mã hợp đồng: <b>{item?.Code}</b>
            </div>
            <div>
              Tên tài sản: <b>{item?.TenTaiSan || ""}</b>
            </div>
            <div>
              Số tiền phải tất toán:{" "}
              <b>{formatNumber(Math.round(item.Sotienvay))}</b>
            </div>
            <div>
              Số tiền đã tất toán:{" "}
              <b>{formatNumber(Math.round(item.TongTien))}</b>
            </div>
            <div>
              Phí khác: <b>{formatNumber(Math.round(item.OtherFee))}</b>
            </div>
            <div>
              Số tiền chênh lệch:{" "}
              <b>
                {formatNumber(
                  Math.round(item.TongTien - item.OtherFee - item.Sotienvay),
                )}
              </b>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            left: 0,
            right: 0,
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "12px",
            paddingTop: "4px",
            paddingLeft: "10px",
            paddingRight: "10px",
            boxSizing: "border-box",
          }}
        >
          <div>{currentUrl}</div>
          <div>Trang 1/1</div>
        </div>
      </div>
    </>
  );
});

export default PhieuInChiTiet;
